import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/opt/build/repo/www/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/www/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/www/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/www/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es6.object.define-property";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import { Context } from './Provider';

var CodeLiveErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(CodeLiveErrorBoundary, _React$Component);

  var _super = _createSuper(CodeLiveErrorBoundary);

  function CodeLiveErrorBoundary() {
    var _this;

    _classCallCheck(this, CodeLiveErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "context", void 0);

    return _this;
  }

  _createClass(CodeLiveErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.context.onError(error);
    }
  }, {
    key: "render",
    value: function render() {
      var Element = this.props.element;
      return typeof Element === 'function' ? /*#__PURE__*/React.createElement(Element, null) : Element;
    }
  }]);

  return CodeLiveErrorBoundary;
}(React.Component);

CodeLiveErrorBoundary.contextType = Context;
export default CodeLiveErrorBoundary;